/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const KeywordScanExtensionResultDTOStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Suspended: 'SUSPENDED',
    Exported: 'EXPORTED',
    Unavaliable: 'UNAVALIABLE',
    WaitingResults: 'WAITING_RESULTS'
};
/**
 * Check if a given object implements the KeywordScanExtensionResultDTO interface.
 */
export function instanceOfKeywordScanExtensionResultDTO(value) {
    return true;
}
export function KeywordScanExtensionResultDTOFromJSON(json) {
    return KeywordScanExtensionResultDTOFromJSONTyped(json, false);
}
export function KeywordScanExtensionResultDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'] == null ? undefined : json['status'],
        'asins': json['asins'] == null ? undefined : json['asins'],
    };
}
export function KeywordScanExtensionResultDTOToJSON(json) {
    return KeywordScanExtensionResultDTOToJSONTyped(json, false);
}
export function KeywordScanExtensionResultDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'asins': value['asins'],
    };
}
